// Arquivo em .js de propósito, ainda que o resto da feature seja TypeScript: o agregador de rotas
// em src/router/index.js usa `import.meta.glob("./*.js")`. Um router .ts não seria coletado e as
// rotas sumiriam sem erro nenhum.
import { ROLES_KANBAN, ROLES_SOLICITACAO } from '@/views/ProjecoesComerciais/constants.ts'

const DEFAULT_URL = '/projecoes-comerciais'

const breadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Projeções Comerciais',
    to: 'ProjecoesComerciaisKanban'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'ProjecoesComerciaisKanban',
    component: () => import('@/views/ProjecoesComerciais/KanbanPage.vue'),
    meta: {
      roles: ROLES_KANBAN,
      title: 'Projeções Comerciais',
      breadcrumb: breadCrumb
    }
  },
  {
    path: `${DEFAULT_URL}/nova`,
    name: 'ProjecoesComerciaisNova',
    component: () => import('@/views/ProjecoesComerciais/NovaSolicitacaoPage.vue'),
    meta: {
      roles: ROLES_SOLICITACAO,
      title: 'Solicitação de Estimativa de Numerário',
      breadcrumb: [
        {
          label: 'Home',
          to: 'Home'
        },
        {
          label: 'Solicitação de Estimativa de Numerário',
          to: 'ProjecoesComerciaisNova'
        }
      ]
    }
  }
]
